import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { makeStyles } from '@material-ui/core/styles';
import {
  Card,
  CardActions,
  CardContent,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  TablePagination
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 1050
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

const ServicesTable = props => {
  const { className, Services, ...rest } = props;

  const classes = useStyles();

  const [selectedServices, setSelectedServices] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);

  const handleSelectAll = event => {
    const { Services } = props;

    let selectedServices;

    if (event.target.checked) {
      selectedServices = Services.map(Service => Service.id);
    } else {
      selectedServices = [];
    }

    setSelectedServices(selectedServices);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedServices.indexOf(id);
    let newSelectedServices = [];

    if (selectedIndex === -1) {
      newSelectedServices = newSelectedServices.concat(selectedServices, id);
    } else if (selectedIndex === 0) {
      newSelectedServices = newSelectedServices.concat(
        selectedServices.slice(1)
      );
    } else if (selectedIndex === selectedServices.length - 1) {
      newSelectedServices = newSelectedServices.concat(
        selectedServices.slice(0, -1)
      );
    } else if (selectedIndex > 0) {
      newSelectedServices = newSelectedServices.concat(
        selectedServices.slice(0, selectedIndex),
        selectedServices.slice(selectedIndex + 1)
      );
    }

    setSelectedServices(newSelectedServices);
  };

  const handlePageChange = (event, page) => {
    setPage(page);
  };

  const handleRowsPerPageChange = event => {
    setRowsPerPage(event.target.value);
  };

  return (
    <Card {...rest} className={clsx(classes.root, className)}>
      <CardContent className={classes.content}>
        <PerfectScrollbar>
          <div className={classes.inner}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell padding="checkbox">
                    <Checkbox
                      checked={selectedServices.length === Services.length}
                      color="primary"
                      indeterminate={
                        selectedServices.length > 0 &&
                        selectedServices.length < Services.length
                      }
                      onChange={handleSelectAll}
                    />
                  </TableCell>
                  <TableCell>Shop Name</TableCell>
                  <TableCell>Service Name</TableCell>
                  <TableCell>Description</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Services.slice(0, rowsPerPage).map(Service => (
                  <TableRow
                    className={classes.tableRow}
                    hover
                    key={Service.id}
                    selected={selectedServices.indexOf(Service.id) !== -1}>
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={selectedServices.indexOf(Service.id) !== -1}
                        color="primary"
                        onChange={event => handleSelectOne(event, Service.id)}
                        value="true"
                      />
                    </TableCell>
                    <TableCell>
                      <div className={classes.nameContainer}>
                        <Typography variant="body1">
                          {Service.shopName}
                        </Typography>
                      </div>
                    </TableCell>
                    <TableCell>
                      <div className={classes.nameContainer}>
                        <Typography variant="body1">{Service.name}</Typography>
                      </div>
                    </TableCell>
                    <TableCell>
                      <div className={classes.nameContainer}>
                        <Typography variant="body1">
                          {Service.description}
                        </Typography>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>
      <CardActions className={classes.actions}>
        <TablePagination
          component="div"
          count={Services.length}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handleRowsPerPageChange}
          page={page}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </CardActions>
    </Card>
  );
};

ServicesTable.propTypes = {
  className: PropTypes.string,
  Services: PropTypes.array.isRequired
};

export default ServicesTable;
